import React, { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import {
  Accordion,
  Alert,
  Button,
  Col,
  Form,
  Row,
  ToggleButton,
  Modal,
  Tooltip,
} from "react-bootstrap";
import OverlayTrigger from "../OverlayTrigger";
import {
  BlueStyledAccordionHeader,
  DarkBlueStyledAccordionHeader,
  GreyStyledAccordionHeader,
  OrangeStyledButton,
  StyledToggleButton,
  StyledForm,
} from "./proposalForm.styled";
import { useDispatch, useSelector } from "react-redux";
import {
  getContactRoles,
  getProjectType,
  getProjectTypeDetail,
  getSectionOrder,
  getSelectedSections,
  getUserProjectType,
  saveProposal,
  updateProposal,
} from "../../store/actions/proposals/proposals.actions";
import { aiTemplate } from "../../store/actions/proposals/proposals.actions";
import "react-intl-tel-input/dist/main.css";
import { FaRobot, FaUndo } from 'react-icons/fa';
import {
  PROPOSAL_RESSET_SECTIONS,
  PROPOSAL_RESSET_VALUES,
  PROPOSAL_SET_SECTIONS,
  PROPOSAL_SET_VALUES,
} from "../../store/constants/proposalConstants";
import { useParams, useSearchParams } from "react-router-dom";
import Spinner from "../spinner/Spinner";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { TOTAL_FREE_MODE_COUNT } from "../../utils/constants/api";
import { getStateLaborPricingList } from "../../store/actions/mortgage_calculator/mortgage_calculator.actions";
import "./index.css";
import { createTemplate } from "../../utils/helpers/helper";
import { fetchSingleProject } from "../../store/actions/projects/projects.action";
import { savePaintProposal, updatePaintProposal } from "../../store/actions/paint_proposal/paint_proposal.action";
import { useFeatureAccess } from "../../hooks/useFeatureAccess";
import CustomPromptModal from "../ProposalPreviewForm/CustomPromptModal";
import { InfoCircle } from "react-bootstrap-icons";
import ArrangeSections from "./ArrangeSections";
import { normalizeSectionOrder } from "../../utils/constants/proposalSectionOrder";

const StyledClearButton = styled(Button)`
  font-size: 12px;
  height: 25px;
  text-transform: lowercase;
  color: #fff;
  float: right;
  &:hover {
    color: #fff;
  }
  &:a {
    color: #fff;
  }
`;

const ProposalForm = ({ setModalShow, setPaymentModalShow }) => {
  const navigate = useNavigate();
  let params = useParams();
  let [searchParams] = useSearchParams();
  const bid_amount = searchParams.get("bidAmount");
  const project_type = searchParams.get("project_type");
  const project_name = searchParams.get("project_name");
  const project_state = searchParams.get("state");
  const project_phase = searchParams.get("phase");
  const project_slug = searchParams.get("url_slug");
  const pressure_washing = searchParams.get("pressure_washing");
  const exterior_cleaning = searchParams.get("exterior_cleaning");
  const pressure_washing_amount = searchParams.get("pressure_washing_amount");
  const exterior_cleaning_amount = searchParams.get("exterior_cleaning_amount");
  const davis = searchParams.get("davis");
  const union = searchParams.get("union");
  const { search } = window.location;
  const show_tab = new URLSearchParams(search).get("bidAmount");
  const { free_mode_count } = useSelector((state) => state.userFreeModeCount);
  const { projectTypeDetail } = useSelector((state) => state.projectTypeDetail);
  const { id } = params;
  const { user } = useSelector((state) => state.auth);
  const { user: profile, loading :profileLoading } = useSelector((state) => state.userDetails);
  const { error: errorForm, loading: createLoader } = useSelector(
    (state) => state.proposalCreate
  );
  const { proposal, loading } = useSelector((state) => state.proposalDetail);
  const { proposalTemplates, loading: templatesLoading, error: templatesError } = useSelector((state) => state.proposalTemplates);
  const ganarpro_app = localStorage.getItem(`ganarpro_app${user?.id}`);
  const paint_app = window.location.pathname?.includes('paint_proposal');
  const { loading: projectDetailsLoading, singleProject } = useSelector((state) => state.projects);
  const values = useSelector((state) => state.proposalValues);
  const sections = useSelector((state) => state.proposalSections);
  const { projectTypes, loading: projectsListLoading } = useSelector((state) => state.projectTypeList);
  const { projectTypes: userProjectTypes, loading: userProjectTypesLoading } = useSelector((state) => state.userProjectTypeList);
  const { roles, loading: rolesLoading } = useSelector((state) => state.contactRolesDetails);
  const { error: updateError } = useSelector((state) => state.projectUpdate);
  const [message] = useState("");
  const { hasFeatureAccess, enforceAccess } = useFeatureAccess(window.location.pathname?.includes('my_proposal') ? "Cleanup Proposal" : "Paint Proposal");
  const [selectedProject, setSelectedProject] = useState({});
  const [showCustomPrompt, setShowCustomPrompt] = useState(false);
  const [customPrompt, setCustomPrompt] = useState('');
  const [loadingMain, setLoadingMain] = useState(false);
  const [loadingPricing, setLoadingPricing] = useState(false);
  const [currentSection, setCurrentSection] = useState('main');
  const { loading: aiLoading, template: aiTemplateResult, error: aiError } = useSelector((state) => state.aiTemplate);
  const [templateHistory, setTemplateHistory] = useState({ main: [], pricing: [] });
  const [currentHistoryIndex, setCurrentHistoryIndex] = useState({ main: 0, pricing: 0 });
  const arrangeStorageKey = user?.id ? `arrangeSectionsOpen_${user.id}` : null;
  const [activeKeys, setActiveKeys] = useState(() => {
    const base = ["0", "1", "2", "3", "4"];
    const key = user?.id ? `arrangeSectionsOpen_${user.id}` : null;
    if (!key) {
      return ["arrange", ...base];
    }
    const saved = localStorage.getItem(key);
    if (saved === "false") {
      return base;
    }
    return ["arrange", ...base];
  });
  const projects_list = ["apartment complex", "hotel", "student housing"]
  const dispatch = useDispatch();

  const addToHistory = (section, content) => {
    setTemplateHistory(prev => {
      const newHistory = { ...prev };
      newHistory[section] = newHistory[section].slice(0, currentHistoryIndex[section] + 1);
      newHistory[section] = [...newHistory[section], content];
      return newHistory;
    });
    setCurrentHistoryIndex(prev => ({
      ...prev,
      [section]: prev[section] + 1
    }));
    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        [`${section}_history`]: templateHistory[section],
        [`${section}_history_index`]: currentHistoryIndex[section] + 1
      }
    });
  };
  
  const handleTemplateUndo = (section) => {
    if (currentHistoryIndex[section] > 0) {
      const newIndex = currentHistoryIndex[section] - 1;
      const previousContent = templateHistory[section][newIndex];
      
      setCurrentHistoryIndex(prev => ({
        ...prev,
        [section]: newIndex
      }));

      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          [`${section}_history_index`]: newIndex
        }
      });

      switch (section) {
        case 'main':
          dispatch({
            type: PROPOSAL_SET_VALUES,
            payload: paint_app ?  { user_scope: previousContent } : { user_template: previousContent }
          });
          break;
        case 'pricing':
          dispatch({
            type: PROPOSAL_SET_VALUES,
            payload: { ai_pricing: newIndex === 0 ? '' : previousContent }
          })
      }
    }
  };

  const renderUndoButton = (section) => {
    const canUndoTemplate = currentHistoryIndex[section] > 0;
    return (
      <div className="d-flex justify-content-between">
        {
          section == 'pricing' &&
          <Button
            variant="light"
            onClick={() => handleTemplateUndo(section)}
            disabled={!canUndoTemplate}
            title="Undo AI Template"
            style={{ maxWidth: 'max-content', marginLeft: 'auto', marginRight: '6px', paddingInline: '10px' }}
          >
            <FaUndo /> Undo Template
          </Button>
        }
      </div>
    );
  };

  useEffect(() => {
    if (aiTemplateResult) {
      if (loadingPricing) {
        setLoadingPricing(false);
        addToHistory('pricing', aiTemplateResult.text);
        
        let bid_amount = String(aiTemplateResult?.bid_amount || "").replaceAll("$", "");
        bid_amount = parseInt(bid_amount)

        dispatch({
          type: PROPOSAL_SET_VALUES,
          payload: { ai_pricing: aiTemplateResult.text, bid_amount: bid_amount }
        });
      } else if (loadingMain) {
        setLoadingMain(false);
        addToHistory('main', aiTemplateResult);
        dispatch({
          type: PROPOSAL_SET_VALUES,
          payload: paint_app ?  { user_scope: aiTemplateResult } : { user_template: aiTemplateResult }
        });
      }
    }
  }, [aiTemplateResult]);

  const handleCustomPrompt = (section = 'main') => {
    setCurrentSection(section);
    setShowCustomPrompt(true);
  };

  const handleSaveCustomPrompt = () => {
    const data = {
      project_name: values?.project_name,
      description: values?.project_description,
      size: values?.project_size,
      units: values?.project_units,
      stage: values?.project_stage,
      address: values?.project_address,
      project_type: values?.project_type,
      section: currentSection,
      custom_prompt: customPrompt
    };
    dispatch(aiTemplate(data));
    setShowCustomPrompt(false);
    setCustomPrompt('');
    if (currentSection === 'pricing') {
      setLoadingPricing(true);
    } else {
      setLoadingMain(true);
    }
  };

  const handleGenerateAiTemplate = (index, section = 'main') => {
    const data = {
      project_name: values?.project_name,
      description: values?.project_description,
      size: values?.project_size,
      units: values?.project_units,
      stage: values?.project_stage,
      address: values?.project_address,
      project_type: values?.project_type,
      section: section,
      index: index,
      project_slug: values?.project_slug
    };
    setCurrentSection(section);
    dispatch(aiTemplate(data));
    if (section === 'pricing') {
      setLoadingPricing(true);
    } else {
      setLoadingMain(true);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    let newValues = values;

    let trueKeys = Object.keys(sections)
      .map((key) => {
        if (sections[key]) {
          return key;
        }
      })
      .filter((key) => key);

    if (user) {
      newValues = {
        ...values,
        ...profile,
        current_date: new Date().toUTCString().slice(0, 16),
      };
    }

    if(paint_app) {
      delete newValues['project_type']
      newValues = {
        ...newValues,
        sections: trueKeys.join(','),
        section_order: normalizeSectionOrder(values.section_order),
      }

      dispatch(savePaintProposal(newValues));

    } else {
      let template =
        values?.user_template ||
        selectedProject?.user_template ||
        selectedProject?.template;
      // let doc = createTemplate(template, newValues);


      newValues = {
        ...newValues,
        project_type: selectedProject?.name,
        user_template: template,
        sections: trueKeys.join(","),
        section_order: normalizeSectionOrder(values.section_order),
      };

      dispatch(saveProposal(newValues));
    }
  };

  const updateHandler = (e) => {
    e.preventDefault();
    let newValues = values;
    let trueKeys = Object.keys(sections)
      .map((key) => {
        if (sections[key]) {
          return key;
        }
      })
      .filter((key) => key);

    if (user) {
      newValues = {
        ...values,
        ...user,
        current_date: new Date().toUTCString().slice(0, 16),
      };
    }

    if (paint_app){
      delete newValues['project_type']
      newValues = {
        ...newValues,
        sections: trueKeys.join(","),
        section_order: normalizeSectionOrder(values.section_order),
      };

      dispatch(updatePaintProposal(id, newValues));

    } else {
      newValues = {
        ...newValues,
        project_type: selectedProject?.name,
        sections: trueKeys.join(","),
        section_order: normalizeSectionOrder(values.section_order),
      };

      dispatch(updateProposal(id, newValues));
    }
  };

  const handleSetModal = (e) => {
    e.preventDefault();
    localStorage.setItem("proposal", JSON.stringify(values));
    setModalShow(true);
  };

  const clearForm = (e) => {
    e.preventDefault();
    dispatch({ type: PROPOSAL_RESSET_VALUES });
    navigate("/my_proposal");
  };

  const handleSetPaymentModalShow = (e) => {
    e.preventDefault();
    localStorage.setItem("proposal", JSON.stringify(values));
    enforceAccess();
  };
  // let isSubActive =
  //   profile?.free_template_count > 0 || profile?.subscription_id;
  const price_id = process.env.REACT_APP_PROPOSAL_APP;
  const price_id_painting = process.env.REACT_APP_GANARPRO_PAINTING;

  let handleButton = submitHandler;
  let buttonText = "Save";
  if (!user) {
    handleButton = handleSetModal;
  } else if (
    !hasFeatureAccess &&
    id
  ) {
    handleButton = handleSetPaymentModalShow;
    buttonText = "Update Proposal";
  } else if (!hasFeatureAccess) {
    handleButton = handleSetPaymentModalShow;
  } else if (user && proposal && id) {
    handleButton = updateHandler;
    buttonText = "Update Proposal";
  }

  const handleChange = (evt) => {
    const { name, value: newValue } = evt.target;

    dispatch({ type: PROPOSAL_SET_VALUES, payload: { [name]: newValue } });
  };

  const handleChangeSection = (evt) => {
    const { name } = evt.target;
    dispatch({
      type: PROPOSAL_SET_SECTIONS,
      payload: { [name]: evt.target.checked },
    });
  };

  const handleChangeProjectType = (e, typeId) => {
    if (!user) {
      setModalShow(true);
      return;
    }

    const { name, value } = e.target;
    let selectedProject = projectTypes.find(
      (projectType) => projectType.name.toLowerCase() === value.toLowerCase()
    );

    if (values?.project_details && selectedProject?.template == null) {
      selectedProject = values.project_details;
    }

    // Update proposal values based on selected project
    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        project_type: selectedProject?.name?.toLowerCase(),
        user_template:
          selectedProject?.user_template || selectedProject?.template,
      },
    });

    // Update phases based on selected project type
    // if (finalCleanProjects.indexOf(selectedProject.name.toLowerCase()) !== -1) {
    //   setPhaseData([{ value: "final", label: "final" }]);
    //   dispatch({ type: PROPOSAL_SET_VALUES, payload: { phases: "final" } });
    // } else if (
    //   selectedProject.name.toLowerCase() === "fluff clean scope alone"
    // ) {
    //   setPhaseData([{ value: "fluff", label: "fluff" }]);
    //   dispatch({ type: PROPOSAL_SET_VALUES, payload: { phases: "fluff" } });
    // } else if (
    //   selectedProject.name.toLowerCase() === "rough clean scope alone"
    // ) {
    //   setPhaseData([{ value: "rough", label: "rough" }]);
    //   dispatch({ type: PROPOSAL_SET_VALUES, payload: { phases: "rough" } });
    // } else {
    //   setPhaseData([
    //     { value: "rough", label: "rough" },
    //     { value: "final", label: "final" },
    //     { value: "fluff", label: "fluff" },
    //   ]);
    // }

    setSelectedProject(selectedProject);
  };

  const handleChangeProposalTemplate = (e) => {
    if (!user) {
      setModalShow(true);
      return;
    }

    const { name, value } = e.target;
    let selectedTemplate = proposalTemplates.find(
      (template) => template.name.toLowerCase() === value.toLowerCase()
    );
    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        proposal_template: selectedTemplate?.name,
        user_scope: selectedTemplate?.user_scope || selectedTemplate?.scope,
        disclosure: selectedTemplate?.disclosure,
        scope_name: `Project Proposal for ${selectedTemplate.name.includes("Paint") ? "Paint" : "Drywall"}`
      },
    });

  };

  const handleResetScope = () => {
    let selectedTemplate = proposalTemplates.find(
      (template) => template.name.toLowerCase() === values?.proposal_template?.toLowerCase()
    );

    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        user_scope: selectedTemplate?.scope,
      },
    });
  };

  const handleResetCleaning = () => {
    const select_project = projectTypes.find((projectType) => {
      return (
        projectType?.name?.toLowerCase() ===
        (values?.project_type?.toLowerCase() ?? "")
      );
    });
    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        user_template: select_project?.template,
      },
    });

    if (sections.pressure_washing && values?.project_type?.toLowerCase() !== "pressure wash") {
      const pressure_wash = projectTypes.find((projectType) => {
        return (projectType.name.toLowerCase() === "pressure wash");
      });
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          template_pressure_wash: pressure_wash.template,
        },
      });
    }

    if (sections.window_cleaning) {
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          user_window_cleaning: values?.default_window_cleaning,
        },
      });
    }

  };

  const handleSelectProject = useCallback(() => {
    let select_project = {};
    let project_type_param;
    if (project_type)
      project_type_param = projects_list.includes(project_type?.toLowerCase()) ? "multifamily-residential" : project_type?.toLowerCase() == 'residential home' ? 'residence home' : project_type?.toLowerCase()
    let value = values?.project_type || project_type_param || "Any Type General Cleaning";
    select_project = projectTypes.find((projectType) => {
      return projectType.name.toLowerCase() == value.toLowerCase();
    });

    if (values?.project_details && select_project?.template == null) {
      select_project = values.project_details;
    }

    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        user_template:
          select_project?.user_template || select_project?.template,
        project_type: select_project?.name?.toLowerCase(),
      },
    });
    setSelectedProject(select_project);
  }, [project_type, values?.project_type, values?.project_details]);

  const handleSinglePrice = (e) => {
    const { name, value } = e.target;
    dispatch({
      type: PROPOSAL_SET_SECTIONS,
      payload: {
        [name]: e.target.checked,
      },
    });
  };

  useEffect(() => {
    if (user) {
      dispatch(getSelectedSections(user?.id));
      dispatch(
        getSectionOrder(user?.id, { paint: paint_app, fromBackend: !id })
      );
    } else {
      dispatch({ type: PROPOSAL_RESSET_SECTIONS });
    }
  }, []);

  useEffect(() => {
    if (projectTypes.length > 0) {
      handleSelectProject();
    }
  }, [projectTypes, handleSelectProject]);

  useEffect(() => {
    if (projectTypes.length === 0) return;
    if (values?.project_details && (values?.project_details?.name || values?.project_details?.template)) {
      setSelectedProject(values.project_details);
      return;
    }
    const projectTypeName = values?.project_type || project_type;
    if (projectTypeName) {
      let project_type_param = projects_list.includes(projectTypeName?.toLowerCase()) ? "multifamily-residential" : projectTypeName?.toLowerCase() == 'residential home' ? 'residence home' : projectTypeName?.toLowerCase();
      const selected = projectTypes.find((p) => p.name?.toLowerCase() === project_type_param?.toLowerCase());
      if (selected) setSelectedProject(selected);
    } else {
      const defaultProject = projectTypes.find((p) => p.name?.toLowerCase() === "any type general cleaning");
      if (defaultProject) setSelectedProject(defaultProject);
    }
  }, [values?.project_type, values?.project_details, id, project_type, projectTypes]);

  useEffect(() => {
    let projects_list = ["apartment complex", "hotel", "student housing"];
    
    if (project_type) {
      let pressure_wash_price = parseFloat(pressure_washing_amount);
      let exterior_cleaning_price = parseFloat(exterior_cleaning_amount);
      let bidAmount = parseFloat(bid_amount).toFixed(2);
      bidAmount = pressure_wash_price ? bidAmount - pressure_wash_price : bidAmount;
      bidAmount = exterior_cleaning_price ? bidAmount - exterior_cleaning_price : bidAmount;

      let rough = 0;
      let final = 0;
      let fluff = 0;
      switch (project_phase) {
        case "rough":
          rough = bidAmount;
          break;
        case "final":
          final = bidAmount;
          break;
        case "fluff":
          fluff = bidAmount;
          break;
        case "rough_final":
        case "final_rough":
          rough = bidAmount * 0.4;
          final = 0.6 * bidAmount;
          break;
        case "rough_fluff":
        case "fluff_rough":
          rough = bidAmount * 0.6;
          fluff = bidAmount * 0.4;
          break;
        case "final_fluff":
        case "fluff_final":
          final = bidAmount * 0.65;
          fluff = 0.35 * bidAmount;
          break;
        case "rough_fluff_final":
        case "rough_final_fluff":
        case "final_fluff_rough":
        case "final_rough_fluff":
        case "fluff_final_rough":
        case "fluff_rough_final":
          rough = bidAmount * 0.3;
          final = bidAmount * 0.5;
          fluff = bidAmount * 0.2;
          break;
        default:
          rough = 0;
          final = 0;
          fluff = 0;
      }

      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          project_type: projects_list.includes(project_type?.toLowerCase()) ? "multifamily-residential" : project_type?.toLowerCase() == 'residential home' ? 'residence home' : project_type?.toLowerCase(),
          project_name,
          project_state,
          phases: project_phase,
          rough_clean_amount: parseInt(rough),
          final_clean_amount: parseInt(final),
          fluff_clean_amount: parseInt(fluff),
          exterior_clean_amount: exterior_cleaning_price,
          pressure_washing_amount: pressure_wash_price,
          bid_amount: bid_amount,
        },
      });

      dispatch(getProjectTypeDetail(project_type));
    } else if (values?.project_type) {
      handleSelectProject();
    }

    if (davis || union || pressure_washing || exterior_cleaning)
      dispatch({
        type: PROPOSAL_SET_SECTIONS,
        payload: {
          davis_bacon: davis == 'true',
          union_requirement: union == 'true',
          pressure_washing: pressure_washing == 'true',
          window_cleaning: exterior_cleaning == 'true'
        }
      })

    dispatch({
      type: PROPOSAL_SET_VALUES,
      payload: {
        project_name,
        project_state,
      },
    });

    if (project_slug) {
      dispatch(fetchSingleProject(project_slug));
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          project_slug
        }
      });
    }

    dispatch(getStateLaborPricingList());

    dispatch(getProjectType());
    dispatch(getUserProjectType());
  }, [
    bid_amount,
    dispatch,
    id,
    project_name,
    project_state,
    project_type,
    project_phase,
  ]);

  useEffect(() => {
    if (project_type) {
      let project_type_param = projects_list.includes(project_type?.toLowerCase()) ? "multifamily-residential" : project_type?.toLowerCase() == 'residential home' ? 'residence home' : project_type?.toLowerCase();
      let selected = projectTypes.find((projectType) => {
        return projectType.name.toLowerCase() == project_type_param;
      });
      setSelectedProject(selected);
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          project_type: selected?.name?.toLowerCase(),
          user_template: selected?.user_template || selected?.template,
        },
      });
    }
  }, [project_type, projectTypes]);

  useEffect(() => {
    if (singleProject) {
      let address =
        singleProject?.address !== null && singleProject?.address !== ""
          ? `${singleProject?.address}, `
          : "";
      address += `${singleProject?.city}, ${singleProject?.state}`;
      dispatch({
        type: PROPOSAL_SET_VALUES,
        payload: {
          project_address: address,
          // ["project_type"]: singleProject?.project_type?.toLowerCase(),
          customer_company_name: singleProject?.account_name,
          customer_address: singleProject?.account_billing_address,
          project_contact_1_name: singleProject?.primary_contact_name,
          project_contact_1_email: singleProject?.primary_contact_email,
          project_contact_1_phone: singleProject?.primary_contact_phone,
          project_description: singleProject?.description,
          project_stage: singleProject?.stage_name,
          project_size: singleProject?.sf_size,
          project_units: singleProject?.units
        },
      });

      if (singleProject.primary_contact_name) {
        dispatch({
          type: PROPOSAL_SET_SECTIONS,
          payload: {
            contact1: true
          }
        })
      }
    }

    if (singleProject) {
      dispatch(getContactRoles(singleProject?.id));
    }
  }, [singleProject]);

  useEffect(() => {
    if (roles) {
      for (let x = 0; x < roles.length; x++) {
        dispatch({
          type: PROPOSAL_SET_SECTIONS,
          payload: {
            [`contact${x + 1}`]: true,
          },
        });

        dispatch({
          type: PROPOSAL_SET_VALUES,
          payload: {
            [`project_contact_${x + 1}_name`]: roles[x]?.name || "",
            [`project_contact_${x + 1}_phone`]: roles[x]?.phone || "",
            [`project_contact_${x + 1}_email`]: roles[x]?.email || "",
          },
        });
      }
      let roles_length = roles.length || 0;
      for (let x = roles_length || 0; x < 5; x++) {
        dispatch({
          type: PROPOSAL_SET_SECTIONS,
          payload: {
            [`contact${x + 1}`]: false,
          },
        });
      }
    }
  }, [roles]);

  useEffect(() => {
    if (!arrangeStorageKey) {
      return;
    }
    const saved = localStorage.getItem(arrangeStorageKey);
    if (saved === null) {
      return;
    }
    const open = saved === "true";
    setActiveKeys((current) => {
      const rest = current.filter((key) => key !== "arrange");
      return open ? ["arrange", ...rest] : rest;
    });
  }, [arrangeStorageKey]);

  const handleAccordionSelect = (eventKey) => {
    const next = Array.isArray(eventKey) ? eventKey : [];
    setActiveKeys(next);
    if (arrangeStorageKey) {
      localStorage.setItem(
        arrangeStorageKey,
        String(next.includes("arrange"))
      );
    }
  };

  return (
    <StyledForm>
      {message && (
        <Alert variant="danger" className="text-capitalize">
          <Alert.Heading>Required Fields!</Alert.Heading>
          {message}
        </Alert>
      )}
      {updateError && (
        <Alert variant="danger">
          <Alert.Heading>Required Fields!</Alert.Heading>
          <ul>
            {Object.keys(updateError).map((error, index) => {
              return (
                <li key={index}>
                  {error} {updateError[error].toString()}
                </li>
              );
            })}
          </ul>
        </Alert>
      )}
      {errorForm && (
        <Alert variant="danger">
          <Alert.Heading>Required Fields!</Alert.Heading>
          <ul>
            {Object.keys(errorForm).map((error, index) => {
              return (
                <li key={index}>
                  {error} {errorForm[error].toString()}
                </li>
              );
            })}
          </ul>
        </Alert>
      )}
      {loading ||
      (paint_app && templatesLoading) ||
      projectDetailsLoading ||
      projectsListLoading ||
      userProjectTypesLoading ||
      rolesLoading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (
        <Accordion activeKey={activeKeys} onSelect={handleAccordionSelect} alwaysOpen>
          <Accordion.Item className="bg-white" eventKey="arrange">
            <GreyStyledAccordionHeader className="fs-1">
              Arrange Sections
            </GreyStyledAccordionHeader>
            <Accordion.Body>
              <ArrangeSections />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item className="bg-white" eventKey="0">
            <GreyStyledAccordionHeader className="fs-1">
              Header Information
            </GreyStyledAccordionHeader>
            <Accordion.Body style={{ textTransform: "capitalize" }}>
              <br />
              <Row>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections?.scope_name
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="scope_name"
                    type="checkbox"
                    variant="outline-secondary"
                    name="scope_name"
                    checked={sections.scope_name}
                    onChange={handleChangeSection}
                  >
                    Scope Name
                  </StyledToggleButton>
                </Form.Group>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.company_name
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="company_name"
                    type="checkbox"
                    variant="outline-secondary"
                    name="company_name"
                    checked={sections.company_name}
                    onChange={handleChangeSection}
                  >
                    Company Name
                  </StyledToggleButton>
                </Form.Group>
              </Row>
              <br />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item className="bg-white" eventKey="1">
            <GreyStyledAccordionHeader className="fs-1">
              Submitted by
            </GreyStyledAccordionHeader>
            <Accordion.Body style={{ textTransform: "capitalize" }}>
              <br />
              <Row>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.contact_name
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="contact_name"
                    type="checkbox"
                    variant="outline-secondary"
                    name="contact_name"
                    checked={sections.contact_name}
                    onChange={handleChangeSection}
                  >
                    Contact Name
                  </StyledToggleButton>
                </Form.Group>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.today_date
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="today_date"
                    type="checkbox"
                    variant="outline-secondary"
                    name="today_date"
                    checked={sections.today_date}
                    onChange={handleChangeSection}
                  >
                    Today Date
                  </StyledToggleButton>
                </Form.Group>
              </Row>
              <br />
              <Row>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.contact_phone_email
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="contact_phone_email"
                    type="checkbox"
                    variant="outline-secondary"
                    name="contact_phone_email"
                    checked={sections.contact_phone_email}
                    onChange={handleChangeSection}
                  >
                    Contact Phone & Email
                  </StyledToggleButton>
                </Form.Group>
              </Row>
              <br />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item className="bg-white" eventKey="2">
            <BlueStyledAccordionHeader className="fs-1">
              Project Information
            </BlueStyledAccordionHeader>
            <Accordion.Body>
              <Row className="my-4">
                <Form.Group as={Col} className="d-flex align-items-end">
                  <StyledToggleButton
                    className={
                      sections.project_address
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="project_address"
                    type="checkbox"
                    variant="outline-secondary"
                    name="project_address"
                    checked={sections.project_address}
                    onChange={handleChangeSection}
                  >
                    Project Address
                  </StyledToggleButton>
                </Form.Group>
              </Row>
              {!profileLoading && paint_app ? (
                <>
                  <Row className="my-3">
                    <Form.Group as={Col}>
                      <Row>
                        <Col lg={7} style={{ alignSelf: "center" }}>
                          <Form.Label className="fw-bolder">
                            Proposal Template{" "}
                            <span className="text-danger fw-bolder">*</span>
                          </Form.Label>
                        </Col>
                        <Col lg={5} className="text-end">
                          <button
                            type="button"
                            className="btn btn-outline-danger mb-1 w-100"
                            style={{ fontSize: "12px" }}
                            onClick={handleResetScope}
                          >
                            Reset Painting Scopes
                          </button>
                        </Col>
                      </Row>
                      <Form.Select
                        name="project_type"
                        onChange={handleChangeProposalTemplate}
                        value={values?.proposal_template?.toLowerCase()}
                        required
                      >
                        {proposalTemplates.filter(p => p?.name !== 'Pricing Template').map((item) => {
                          return (
                            <option key={item.id} value={item.name.toLowerCase()}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                    <br />
                    <br />
                  </Row>
                  <br /> 
                  <Row className="gap-2 justify-content-between">
                    <Form.Label className="fw-bolder">Generate AI Scope of Work</Form.Label>
                    {renderUndoButton('main')}
                    <div className="d-flex gap-2">
                      <Button 
                        variant="primary"
                        onClick={() => handleGenerateAiTemplate(3, 'main')}
                        disabled={aiLoading}
                        className="w-100 fs-5"
                      >
                        <FaRobot className="me-2 pb-1" size={18} />
                        Interior-Only{" "}
                        {aiLoading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </Button>
                      <Button 
                        variant="success"
                        onClick={() => handleGenerateAiTemplate(4, 'main')}
                        disabled={aiLoading}
                        className="w-100 fs-5"
                      >
                        <FaRobot className="me-2 pb-1" size={18} />
                        Full Interior & Exterior{" "}
                        {aiLoading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </Button>
                    </div>
                    <div className="d-flex gap-2">
                      <Button 
                        variant="info"
                        onClick={() => handleGenerateAiTemplate(5, 'main')}
                        disabled={aiLoading}
                        className="w-100 fs-5"
                      >
                        <FaRobot className="me-2 pb-1" size={18} />
                        Interior + Exterior + Specialty Surfaces{" "}
                        {aiLoading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </Button>
                      <Button 
                        variant="secondary"
                        onClick={() => handleCustomPrompt('main')}
                        disabled={aiLoading}
                        className="w-100 fs-5"
                      >
                        <FaRobot className="me-2 pb-1" size={18} />
                        Custom Prompt{" "}
                        {aiLoading && (
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        )}
                      </Button>
                    </div>
                  </Row>
                  {paint_app && (
                    <>
                      <br />
                      <Row className="gap-2 justify-content-between">
                        <Form.Label className="fw-bolder">Generate AI Pricing </Form.Label>
                        {renderUndoButton('pricing')}
                        <div className="d-flex gap-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip style={{ textAlign: "left", maxWidth: "300px" }}>
                                <div style={{ textAlign: "left" }}>
                                  <strong>Market-Win Strategy</strong><br/>
                                  <strong>Margin:</strong> ~7%<br/>
                                  <strong>Purpose:</strong> Lowest competitive bid to win jobs when competition is tight and GCs focus on price.<br/>
                                  <strong>Best for:</strong> Commodity projects, large apartment complexes, straightforward repaint jobs.
                                </div>
                              </Tooltip>
                            }
                          >
                            <Button 
                              variant="primary"
                              onClick={() => handleGenerateAiTemplate(0, 'pricing')}
                              disabled={aiLoading || loadingMain}
                              className="w-100 fs-5"
                            >
                              <FaRobot className="me-2 pb-1" size={18} />
                              Market-Win
                              {(aiLoading && loadingPricing) && (
                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                              )}
                            </Button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip style={{ textAlign: "left", maxWidth: "300px" }}>
                                <div style={{ textAlign: "left" }}>
                                  <strong>Lean Strategy</strong><br/>
                                  <strong>Margin:</strong> ~15%<br/>
                                  <strong>Purpose:</strong> Balanced bid with healthy margin while remaining competitive.<br/>
                                  <strong>Best for:</strong> Standard go-to mode for most bids. Covers unexpected overruns without being priced out.
                                </div>
                              </Tooltip>
                            }
                          >
                            <Button 
                              variant="success"
                              onClick={() => handleGenerateAiTemplate(1, 'pricing')}
                              disabled={aiLoading || loadingMain}
                              className="w-100 fs-5"
                            >
                              <FaRobot className="me-2 pb-1" size={18} />
                              Lean
                              {(aiLoading && loadingPricing) && (
                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                              )}
                            </Button>
                          </OverlayTrigger>
                        </div>
                        <div className="d-flex gap-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip style={{ textAlign: "left", maxWidth: "300px" }}>
                                <div style={{ textAlign: "left" }}>
                                  <strong>Profit-Heavy Strategy</strong><br/>
                                  <strong>Margin:</strong> ~28%<br/>
                                  <strong>Purpose:</strong> Premium bid for projects with complexity, risk, or rush requirements.<br/>
                                  <strong>Best for:</strong> Specialized coatings, night shifts, high scaffolding costs, or when GC/client values reliability over price.
                                </div>
                              </Tooltip>
                            }
                          >
                            <Button 
                              variant="info"
                              onClick={() => handleGenerateAiTemplate(2, 'pricing')}
                              disabled={aiLoading || loadingMain}
                              className="w-100 fs-5"
                            >
                              <FaRobot className="me-2 pb-1" size={18} />
                              Profit-Heavy
                              {(aiLoading && loadingPricing) && (
                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                              )}
                            </Button>
                          </OverlayTrigger>
                          <Button 
                            variant="secondary"
                            onClick={() => handleCustomPrompt('pricing')}
                            disabled={aiLoading || loadingMain}
                            className="w-100 fs-5"
                          >
                            <FaRobot className="me-2 pb-1" size={18} />
                            Custom Prompt
                            {(aiLoading && loadingPricing) && (
                              <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                            )}
                          </Button>
                        </div>
                      </Row>
                    </>
                  )}
                  <br />
                </>
              ) : !profileLoading ? (
                <>
                  <Row className="my-3">
                  <Form.Group as={Col}>
                    <Row>
                      <Col lg={7} style={{ alignSelf: "center" }}>
                        <Form.Label className="fw-bolder">
                          Project Scope Type{" "}
                          <span className="text-danger fw-bolder">*</span>
                        </Form.Label>
                      </Col>
                      <Col lg={5} className="text-end">
                        <button
                          type="button"
                          className="btn btn-outline-danger mb-1 w-100"
                          style={{ fontSize: "12px" }}
                          onClick={handleResetCleaning}
                        >
                          Reset Cleaning Scopes
                        </button>
                      </Col>
                    </Row>
                    <Form.Select
                      name="project_type"
                      onChange={(e) => handleChangeProjectType(e, e.target.value)}
                      value={selectedProject?.name?.toLowerCase()}
                      required
                    >
                      {projectTypes.map((item) => {
                        return (
                          <option key={item.id} value={item.name.toLowerCase()}>
                            {item.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                  <br />
                  <br />
                  <br />
                  {/* <Form.Group>
                    <Select
                      value={values?.phases
                        ?.split("_")
                        .filter((name) => name)
                        .map((name) => ({
                          value: name,
                          label: name,
                        }))}
                      isMulti
                      name="phase"
                      options={phaseData}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={handleSelect}
                    />
                  </Form.Group> */}
                </Row>
                <Form.Group as={Col} style={{ marginLeft: '8px', textTransform: 'math-auto' }}>
                  <Form.Check
                    type="checkbox"
                    name="single_bid_amount"
                    label="Do not break out phase pricing"

                    checked={sections?.single_bid_amount}
                    onClick={handleSinglePrice}
                  />
                </Form.Group>
                <br /> 
                <Row className="gap-2 justify-content-between">
                  <Form.Label className="fw-bolder">Generate AI Scope of Work</Form.Label>
                  {renderUndoButton('main')}
                  <div className="d-flex gap-2">
                    <Button 
                      variant="primary"
                      onClick={() => handleGenerateAiTemplate(0)}
                      disabled={aiLoading}
                      className="w-100 fs-5"
                    >
                      <FaRobot className="me-2 pb-1" size={18} />
                      Final Cleaning{" "}
                      {aiLoading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                    </Button>
                    <Button 
                      variant="success"
                      onClick={() => handleGenerateAiTemplate(1)}
                      disabled={aiLoading}
                      className="w-100 fs-5"
                    >
                      <FaRobot className="me-2 pb-1" size={18} />
                      Final Cleaning + Windows{" "}
                      {aiLoading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                    </Button>
                  </div>
                  <div className="d-flex gap-2">
                    <Button 
                      variant="info"
                      onClick={() => handleGenerateAiTemplate(2)}
                      disabled={aiLoading}
                      className="w-100 fs-5"
                    >
                      <FaRobot className="me-2 pb-1" size={18} />
                      Three-Phase Cleaning{" "}
                      {aiLoading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                    </Button>
                    <Button 
                      variant="secondary"
                      onClick={() => handleCustomPrompt('main')}
                      disabled={aiLoading}
                      className="w-100 fs-5"
                    >
                      <FaRobot className="me-2 pb-1" size={18} />
                      Custom Prompt{" "}
                      {aiLoading && (
                        <span
                          className="spinner-border spinner-border-sm ms-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                    </Button>
                  </div>
                </Row>
                <br />
                <Row>
                  <Form.Group as={Row}>
                    <Form.Label className="fw-bolder">Bid amount</Form.Label>
                    <div className="col-6 h-75">
                      <StyledToggleButton
                        className={
                          sections.window_cleaning
                            ? "toggle-checked-grey mb-2 w-100"
                            : "toggle-grey mb-2 w-100"
                        }
                        id="window_cleaning"
                        type="checkbox"
                        variant="outline-secondary"
                        name="window_cleaning"
                        checked={sections.window_cleaning}
                        onChange={handleChangeSection}
                      >
                        Exterior Window Cleaning
                      </StyledToggleButton>
                    </div>
                    <div className="col-6 h-75">
                      <StyledToggleButton
                        className={
                          sections.pressure_washing
                            ? "toggle-checked-grey mb-2 w-100"
                            : "toggle-grey mb-2 w-100"
                        }
                        id="pressure_washing"
                        type="checkbox"
                        variant="outline-secondary"
                        name="pressure_washing"
                        checked={sections.pressure_washing}
                        onChange={handleChangeSection}
                      >
                        Pressure Washing
                      </StyledToggleButton>
                    </div>
                  </Form.Group>
                </Row>
              </>
              ) : ''}
              <Row className="mt-3">
                <Form.Group as={Row}>
                  <div className="col-6 h-100">
                    <StyledToggleButton
                      className={
                        sections.davis_bacon
                          ? "toggle-checked-grey mb-2 w-100"
                          : "toggle-grey mb-2 w-100"
                      }
                      id="davis_bacon"
                      type="checkbox"
                      variant="outline-secondary"
                      name="davis_bacon"
                      checked={sections.davis_bacon}
                      onChange={handleChangeSection}
                    >
                      Davis-Bacon Prevailing Wage
                    </StyledToggleButton>
                  </div>
                  <div className="col-6 h-100">
                    <StyledToggleButton
                      className={
                        sections.union_requirement
                          ? "toggle-checked-grey mb-2 w-100"
                          : "toggle-grey mb-2 w-100"
                      }
                      id="union_requirement"
                      type="checkbox"
                      variant="outline-secondary"
                      name="union_requirement"
                      checked={sections.union_requirement}
                      onChange={handleChangeSection}
                    >
                      Union Requirement
                    </StyledToggleButton>
                  </div>
                </Form.Group>
              </Row>
              <br />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item className="bg-white" eventKey="3">
            <DarkBlueStyledAccordionHeader>
              Customer Information
            </DarkBlueStyledAccordionHeader>
            <Accordion.Body>
              <Row className="my-4">
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.client_name
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="client_name"
                    type="checkbox"
                    variant="outline-secondary"
                    name="client_name"
                    checked={sections.client_name}
                    onChange={handleChangeSection}
                  >
                    Client Name
                  </StyledToggleButton>
                </Form.Group>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.client_address
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="client_address"
                    type="checkbox"
                    variant="outline-secondary"
                    name="client_address"
                    checked={sections.client_address}
                    onChange={handleChangeSection}
                  >
                    Client Address
                  </StyledToggleButton>
                </Form.Group>
              </Row>

              <Row className="my-4">
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.contact1
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="contact1"
                    type="checkbox"
                    variant="outline-secondary"
                    name="contact1"
                    checked={sections.contact1}
                    onChange={handleChangeSection}
                  >
                    Contact 1
                  </StyledToggleButton>
                </Form.Group>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.contact2
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="contact2"
                    type="checkbox"
                    variant="outline-secondary"
                    name="contact2"
                    checked={sections.contact2}
                    onChange={handleChangeSection}
                  >
                    Contact 2
                  </StyledToggleButton>
                </Form.Group>
              </Row>
              <Row className="my-4">
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.contact3
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="contact3"
                    type="checkbox"
                    variant="outline-secondary"
                    name="contact3"
                    checked={sections.contact3}
                    onChange={handleChangeSection}
                  >
                    Contact 3
                  </StyledToggleButton>
                </Form.Group>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.contact4
                        ? "toggle-checked-grey mb-2 w-100"
                        : "toggle-grey mb-2 w-100"
                    }
                    id="contact4"
                    type="checkbox"
                    variant="outline-secondary"
                    name="contact4"
                    checked={sections.contact4}
                    onChange={handleChangeSection}
                  >
                    Contact 4
                  </StyledToggleButton>
                </Form.Group>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item className="bg-white" eventKey="4">
            <GreyStyledAccordionHeader>
              Signature Block
            </GreyStyledAccordionHeader>
            <Accordion.Body>
              <Row className="my-4">
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.sign
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="sign"
                    type="checkbox"
                    variant="outline-secondary"
                    name="sign"
                    checked={sections.sign}
                    onChange={handleChangeSection}
                  >
                    Sign
                  </StyledToggleButton>
                </Form.Group>
                {!paint_app &&
                  <Form.Group as={Col}>
                    <StyledToggleButton
                      className={
                        sections.disclosure
                          ? "toggle-checked-grey mb-2 w-100"
                          : "mb-2 w-100"
                      }
                      id="disclosure"
                      type="checkbox"
                      variant="outline-secondary"
                      name="disclosure"
                      checked={sections.disclosure}
                      onChange={handleChangeSection}
                    >
                      Disclosure
                    </StyledToggleButton>
                  </Form.Group>
                }
              </Row>

              <Row className="my-4">
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.footer
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="footer"
                    type="checkbox"
                    variant="outline-secondary"
                    name="footer"
                    checked={sections.footer}
                    onChange={handleChangeSection}
                  >
                    Footer
                  </StyledToggleButton>
                </Form.Group>
                <Form.Group as={Col}>
                  <StyledToggleButton
                    className={
                      sections.logo
                        ? "toggle-checked-grey mb-2 w-100"
                        : "mb-2 w-100"
                    }
                    id="logo"
                    type="checkbox"
                    variant="outline-secondary"
                    name="logo"
                    checked={sections.logo}
                    onChange={handleChangeSection}
                  >
                    Logo
                  </StyledToggleButton>
                </Form.Group>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
          <Row>
            <Col className="text-center p-5">
              <OrangeStyledButton
                variant="warning"
                type="submit"
                onClick={handleButton}
                disabled={createLoader || loading}
              >
                <h4 className="p-2">
                  {" "}
                  {buttonText}{" "}
                  {(createLoader || loading) && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                  <span className="visually-hidden">Loading...</span>{" "}
                </h4>
              </OrangeStyledButton>
            </Col>
          </Row>
        </Accordion>
      )}
      
      <CustomPromptModal
        show={showCustomPrompt}
        onHide={() => setShowCustomPrompt(false)}
        customPrompt={customPrompt}
        setCustomPrompt={setCustomPrompt}
        onSave={handleSaveCustomPrompt}
        loading={aiLoading}
        section={currentSection}
      />
    </StyledForm>
  );
};
export default ProposalForm;
